import { defineMessages } from 'react-intl';

const trns = defineMessages({
  serviceDescription: {
    id: 'CHugIQ',
    defaultMessage:
      'Довідник лікарських засобів, дієтичних добавок, медичних виробів, косметичних засобів, продуктів клінічного і дитячого харчування, зареєстрованих і представлених на фармацевтичному ринку України.'
  },
  catalog: {
    id: '1Sjsv1',
    defaultMessage: 'Каталог товарів'
  },
  subscribeToEmail: {
    id: 'xsIJ83',
    defaultMessage:
      "Наразі ми розвиваємося, щодня покращуємо сервіс та у нас постійно з'являється багато нового. Будьте першими - отримайте бонуси для перших користувачів!"
  },
  feedbackDescription: {
    id: 'O+hrOS',
    defaultMessage:
      'Ми працюємо для вас, тож якщо у вас є ідеї, як нам стати ще зручніше та корисніше – ми відкриті до пропозицій.'
  },
  shareWithFriend: {
    id: 'DmWbtK',
    defaultMessage:
      'Поділіться посиланням на корисний сервіс зі своїми близькими та знайомими.'
  },
  feedFormButtonTitle: {
    id: '0ZHkfa',
    defaultMessage: 'НАПИШІТЬ НАМ'
  },
  feedFormButtonDescription: {
    id: 'nyCjgw',
    defaultMessage: '(ФОРМА ЗВОРОТНЬОГО ЗВ’ЯЗКУ)'
  },
  subscribeToEmailButton: {
    id: 'IAS+ig',
    defaultMessage: 'Підписатися на розсилку'
  },
  yourEmail: {
    id: '+gQBOl',
    defaultMessage: 'Ваш e-mail'
  },
  thanks: {
    id: 'XUWh8i',
    defaultMessage: 'ДЯКУЄМО!'
  },
  yourDataHaveBeenAdded: {
    id: 'K9Gm9x',
    defaultMessage: 'Ваші дані внесені до бази розсилок LikiE'
  },
  close: {
    id: '3hDwzj',
    defaultMessage: 'Закрити'
  },
  sendAFeedback: {
    id: 'Sl/Epx',
    defaultMessage: 'Надіслати повідомлення'
  },
  yourName: {
    id: '0d0d8h',
    defaultMessage: 'Ваше ім’я'
  },
  yourPhone: {
    id: 'hbCUCY',
    defaultMessage: 'Ваш телефон'
  },
  yourMessage: {
    id: 'ouwgwv',
    defaultMessage: 'Ваше повідомлення'
  },
  send: {
    id: 'f7wcVH',
    defaultMessage: 'Надіслати'
  },
  privacyPolicy: {
    id: 'u/s7LA',
    defaultMessage: 'Правила та умови'
  },
  help: {
    id: 'OUNj6I',
    defaultMessage: 'Допомога'
  },
  tips: {
    id: 'Bg+SsQ',
    defaultMessage: 'Блог'
  },
  partners: {
    id: '0kWA9C',
    defaultMessage: 'Партнерам'
  },
  hologram: {
    id: 'dd49Hp',
    defaultMessage: '© 2022 Likie. Усі права захищені'
  },
  users: {
    id: 'H/drii',
    defaultMessage: 'Користувачам'
  },
  information: {
    id: 'Rsbe11',
    defaultMessage: 'інформация'
  },
  messageAboutBonus: {
    id: 'b6ii4K',
    defaultMessage:
      "Ми наразі розвиваємося і щодня покращуємо сервіс, у нас постійно з'являється багато нового. Будьте першими і не пропустіть бонуси для перших користувачів."
  },
  category: {
    id: 'WhHZYX',
    defaultMessage: 'Категорії'
  },
  titleModal: {
    id: '/QnQQs',
    defaultMessage: 'Дякуємо за підписку'
  },
  infoModal: {
    id: 'PW2JYD',
    defaultMessage:
      'Слідкуйте за новинами і отримуйте акційні пропозиції серед перших.'
  },
  titleButton: {
    id: '3hDwzj',
    defaultMessage: 'Закрити'
  },
  placeholder: {
    id: '+gQBOl',
    defaultMessage: 'Ваш e-mail'
  },
  inputButtonTitle: {
    id: 'B7Wusl',
    defaultMessage: 'Підписатися'
  },
  category1: {
    id: '7Q4uY3',
    defaultMessage: 'Медикаменти'
  },
  category2: {
    id: 'C1UCDn',
    defaultMessage: 'БАДи та вітаміни'
  },
  category3: {
    id: '6esCdT',
    defaultMessage: 'Сексуальне здоров’я'
  },
  category4: {
    id: 'HtLtPW',
    defaultMessage: 'Косметика та гігієна'
  },
  category5: {
    id: 'e4aaJG',
    defaultMessage: 'Медичні товари'
  },
  category6: {
    id: 'FMXWO1',
    defaultMessage: 'Товари для косметологів'
  },
  category7: {
    id: '9zo3p0',
    defaultMessage: 'Товари для мам і дітей'
  },
  requiredFieldLabel: {
    id: 'asJvhP',
    defaultMessage: "Обов'язкове полe"
  },
  incorrectEmail: {
    id: 'mFzdvn',
    defaultMessage:
      'Електронна пошта повинна відповідати формі example@email.com'
  },
  aboutUs: {
    id: 'RAlXQq',
    defaultMessage: 'Про компанiю'
  }
});

export default trns;
